/**
 * Small decorative ornament — used between content sections on inner pages.
 */
export default function SectionOrnament({ tone = "light" }) {
  const dark = tone === "dark";
  return (
    <div className="flex items-center justify-center py-8 md:py-10">
      <span className={`block h-px w-12 ${dark ? "bg-[rgba(184,148,86,0.4)]" : "bg-[var(--gold)]/40"}`} />
      <span className={`mx-3 inline-flex items-center justify-center w-8 h-8 rotate-45 border ${dark ? "border-[rgba(184,148,86,0.55)]" : "border-[var(--gold)]"}`}>
        <span className={`block w-1.5 h-1.5 rounded-full ${dark ? "bg-[var(--gold-light)]" : "bg-[var(--gold)]"}`} />
      </span>
      <span className={`block h-px w-12 ${dark ? "bg-[rgba(184,148,86,0.4)]" : "bg-[var(--gold)]/40"}`} />
    </div>
  );
}
